<mat-toolbar class="primary-toolbar" *ngIf="isToolbarShow">
<mat-toolbar-row>
   <span >
        <img src="https://iea-dev.innate.ly/assets/images/access-logo-wkspc-nav.png" alt="logo" height="50" class="logo">
    </span>
    <!-- <span class="vl"></span> -->
    <!-- <span>IEA DATABASE NAME</span> -->
   <span class="menu-spacer col"></span>
   <span>
    <button mat-button (click)="goToCalendar()">
        <mat-icon>date_range</mat-icon>Show Calendar
    </button>
   </span>
   <span>
    <button mat-button (click)="goToReporting()">
        <mat-icon>description</mat-icon>Reporting
    </button>
   </span>
   <span>
    <button mat-button (click)="goToTransactions()">
        <mat-icon>payment</mat-icon>Transactions
    </button>
   </span>
   <button 
   mat-button
   *ngIf="seasonList?.length"
   [matMenuTriggerFor]="menu" 
   class="next-btn o-button button-name-nav">
    <span class="wks-menu-btn"><span>{{selectedSeason?.season?.name}}</span><mat-icon >arrow_drop_down</mat-icon></span>
   </button>
   </mat-toolbar-row>
</mat-toolbar>
<mat-menu #menu="matMenu" class="wks-menu">
    <div class="wks-menu">
        <button mat-menu-item  
        *ngFor="let season of seasonList"
        (click)="onChangeSeason(season, true)"
        
        >{{season?.season?.name}}</button>
    </div>

</mat-menu>

<mat-sidenav-container >
 <mat-sidenav
   #sideNav
   [mode]="windowMode"
   fixedInViewport
   [opened]="isOpenSidnav"
   position="start"
   [fixedTopGap]="64"
   class="sidenav"
    *ngIf="isToolbarShow"
 >
   <section class="row u-profile mt-2 p-2">
     <span class="col-12 text-center">
      <span *ngIf="!profilePic" matTooltip="Upload Photo" matTooltipPosition="right" (click)="goToProfile()" class="cursor-pointer">
        <img src="/assets/images/profile-default-icon.png" alt="" height="100" width="100">
      </span>
       <img *ngIf="profilePic" [src]="profilePic" alt="" class="profile-pic">
     </span>
     <span class="col-12 text-center mt-2 q-header f-info">
       {{loggedInUserName}}
     </span>
     <span class="col-12 text-center mt-1 text-info">
       {{role | roleLabel}}
     </span>
   </section>
   <section style="margin-bottom: 50px;">
     <mat-nav-list *ngFor="let route of routLinks" >
         <a
           mat-list-item
           *ngIf="route.type == 'link' && !route.children && route.roles.includes(role)"
           routerLinkActive="active"
           [routerLink]="route.link"
           class="nav-list-border-bottom"
           >
           <!-- (click)="!route.children ? sideNav.toggle() : ''" -->
           <span class="list-item">
             <mat-icon *ngIf="route.icon" class="material-symbols-outlined f-info">{{route?.icon}}</mat-icon>
             <span class="f-info">{{route.name}}</span>
            </span>
         </a>
         <cdk-accordion 
         *ngIf="route.children && route.roles.includes(role)" 
         class="example-accordion">
            <cdk-accordion-item
              #accordionItem="cdkAccordionItem"
              role="button"
              tabindex="0"
              [attr.id]="'accordion-header-'"
              [attr.aria-expanded]="accordionItem.expanded"
              [attr.aria-controls]="'accordion-body-'"
              >
              <span class="list-item child-nav-item nav-list-border-bottom" (click)="accordionItem.toggle()">
                <mat-icon *ngIf="route.icon && route.name !== 'Performance'" class="material-symbols-outlined f-info">{{route?.icon}}</mat-icon>
                <span *ngIf="route.name === 'Performance'" class="material-symbols-outlined f-info" style="margin-right: 15px;">
                  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.5 10.0001C15.5 10.0001 16.5273 9.52443 16.5 9.50018M16.5 9.50018C12.5961 6.03149 13.0093 3.09979 6.55444 3.0998C5.88778 2.5998 3.5545 1.10015 3.5545 1.50015C3.5545 1.90015 4.66667 3.66681 5 4.00015C4.66667 4.16681 4.09359 4.81297 4 5.00015C3 7.00015 1.55444 7.5998 1.0545 8.5998C0.654496 10.9998 2.5545 10.2665 3.5545 9.5998C4.89495 8.70617 6.55444 9.09979 8.05444 8.09979C10.0544 8.59979 7.55444 12.0998 10.0544 17.0998C14.5544 14.5998 12.5 11.0002 16.5 9.50018Z" stroke="black"/>
                    </svg>              
                </span>
                <div class="d-flex justify-content-between w-auto align-items-center" style="width: 100%;">
                  <span class="f-info ">{{route.name}} </span>
                  <mat-icon>{{ accordionItem.expanded ? 'arrow_drop_down' : 'arrow_drop_up' }}</mat-icon>
                </div>
              </span>
              <div
                class="example-accordion-item-body"
                role="region"
                [style.display]="accordionItem.expanded ? '' : 'none'"
                [attr.id]="'accordion-body-'"
                [attr.aria-labelledby]="'accordion-header-'">
                <mat-nav-list *ngFor="let sbuRoute of route.children" >
                  <a
                  mat-list-item
                  *ngIf="sbuRoute.type == 'link' && (!sbuRoute.roles || sbuRoute.roles.includes(role))"
                  routerLinkActive="active"
                  [routerLink]="sbuRoute.link"
                  class="nav-list-border-bottom"
                  >
                  <!-- (click)="sideNav.toggle()" -->
                  <span class="list-item"                  
                  style="margin-left: 30px;"
                  >
                    <mat-icon *ngIf="sbuRoute.icon" class="material-symbols-outlined f-info">{{sbuRoute.icon}}</mat-icon>
                    <span class="f-info">{{sbuRoute.name}}</span></span>
                </a>

                </mat-nav-list>
              </div>
            </cdk-accordion-item>
        </cdk-accordion>
        
        

     </mat-nav-list>
   </section>
   <section style="position: absolute; bottom: 6px;" style="width: 100%;">
     <button 
     mat-flat-button
     class="logout-btn"
     (click)="logout('loguot')"
     >
     <span><mat-icon class="material-symbols-outlined f-info">logout</mat-icon>Logout</span>
     </button>
   </section>
 </mat-sidenav>
 <mat-toolbar class="secondary-toolbar" *ngIf="isToolbarShow">
    <mat-toolbar-row >
        <span >
            <button mat-icon-button
            (click)="sideNav?.toggle()"
            > <mat-icon >menu</mat-icon>
            </button>
        </span>
        <span class="work-dash">
            <small>WORKSPACE DASHBOARD</small>
        </span>
    </mat-toolbar-row>
 </mat-toolbar>
    <ng-content></ng-content>
    <eq-footer *ngIf="isToolbarShow && showOneEquineLogoInFooter"></eq-footer>
</mat-sidenav-container>

